import { render, staticRenderFns } from "./About.vue?vue&type=template&id=0539b581&scoped=true"
import script from "./about.js?vue&type=script&lang=js&external"
export * from "./about.js?vue&type=script&lang=js&external"
import style0 from "./about.scss?vue&type=style&index=0&id=0539b581&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539b581",
  null
  
)

export default component.exports